import React from 'react'
import label from "../../../common/labels/common_en.json";


const DevideTableColumn = ({ chunkData }) => {
  return (
    <div className="table-responsive answerKeyTable dt-m-none" id="InterviewReport">
      <table className="table text-center">
        <thead>
          <tr className='thisis chunk'>
            <th className="border" >{label.Mark}</th>
            <th className="border" colspan="4">{label.Open}</th>
            <th className="border" colspan="6">{label.SC}</th>
            <th className="border" colspan="6">{label.ST}</th>
          </tr>
          <tr>
            <td className="border"></td>
            <td className="border text-nowrap" colspan="2"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="2"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>

          </tr>
          <tr>
            <td className="border"></td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>

          </tr>
        </thead>
        {chunkData?.map((record, index) => {

          return <React.Fragment key={index}>

            <tbody className='border-none'>
              <tr >
                <td className="border">{record.marks}</td>

                <td className="border">{record.open?.general?.openCompatibleCount ? record.open.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.open?.general?.total ? record.open.general.total : '-'}</td>
                <td className="border">{record.open?.female?.openCompatibleCount ? record.open.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.open?.female?.total ? record.open.female.total : '-'}</td>

                <td className="border">{record.sc?.general?.openCompatibleCount ? record.sc.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.sc?.general?.openIncompatibleCount ? record.sc.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.sc?.general?.total ? record.sc.general.total : '-'}</td>
                <td className="border">{record.sc?.female?.openCompatibleCount ? record.sc.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.sc?.female?.openCompatibleCount ? record.sc.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.sc?.female?.total ? record.sc.female.total : '-'}</td>

                <td className="border">{record.st?.general?.openCompatibleCount ? record.st.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.st?.general?.openIncompatibleCount ? record.st.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.st?.general?.total ? record.st.general.total : '-'}</td>
                <td className="border">{record.st?.female?.openCompatibleCount ? record.st.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.st?.female?.openIncompatibleCount ? record.st.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.st?.female?.total ? record.st.female.total : '-'}</td>
              </tr>
            </tbody>
          </React.Fragment>
        })}
        <tr></tr>
        <br />
        <thead>
          <tr className='thisis chunk'>
            <th className="border" >{label.Mark}</th>
            <th className="border" colspan="6">{label.DTA}</th>
            <th className="border" colspan="6">{label.NTB}</th>
            <th className="border" colspan="3">{label.SBC}</th>
            {/* <th className="border" colspan="6">NT-C</th> */}
          </tr>
          <tr>
            <td className="border"></td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>

          </tr>
          <tr>
            <td className="border"></td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            {/* <td className="border font-weight-bold">1</td>
                    <td className="border font-weight-bold">2</td>
                    <td className="border font-weight-bold">Total</td> */}
          </tr>
        </thead>
        {chunkData?.map((record, index) => {

          return <React.Fragment key={index}>

            <tbody className='border-none'>
              <tr >
                <td className="border">{record.marks}</td>
                <td className="border">{record.dta?.general?.openCompatibleCount ? record.dta.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.dta?.general?.openIncompatibleCount ? record.dta.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.dta?.general?.total ? record.dta.general.total : '-'}</td>
                <td className="border">{record.dta?.female?.openCompatibleCount ? record.dta.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.dta?.female?.openIncompatibleCount ? record.dta.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.dta?.female?.total ? record.dta.female.total : '-'}</td>
                <td className="border">{record.ntb?.general?.openCompatibleCount ? record.ntb.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.ntb?.general?.openIncompatibleCount ? record.ntb.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.ntb?.general?.total ? record.ntb.general.total : '-'}</td>
                <td className="border">{record.ntb?.female?.openCompatibleCount ? record.ntb.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.ntb?.female?.openIncompatibleCount ? record.ntb.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.ntb?.female?.total ? record.ntb.female.total : '-'}</td>
                <td className="border">{record.sbc?.general?.openCompatibleCount ? record.sbc.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.sbc?.general?.openIncompatibleCount ? record.sbc.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.sbc?.general?.total ? record.sbc.general.total : '-'}</td>
              </tr>
            </tbody>
          </React.Fragment>
        })}
        <br />
        <thead>
          <tr className='thisis chunk'>
            <th className="border" >{label.Mark}</th>
            <th className="border" colspan="3">{label.SBC}</th>
            <th className="border" colspan="6">{label.NTC}</th>
            <th className="border" colspan="6">{label.NTD}</th>
          </tr>
          <tr>
            <td className="border"></td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
          </tr>
          <tr>
            <td className="border"></td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
          </tr>
        </thead>
        {chunkData?.map((record, index) => {

          return <React.Fragment key={index}>

            <tbody className='border-none'>
              <tr >
                <td className="border">{record.marks}</td>

                <td className="border">{record.sbc?.female?.openCompatibleCount ? record.sbc.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.sbc?.female?.openIncompatibleCount ? record.sbc.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.sbc?.female?.total ? record.sbc.female.total : '-'}</td>

                <td className="border">{record.ntc?.general?.openCompatibleCount ? record.ntc.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.ntc?.general?.openIncompatibleCount ? record.ntc.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.ntc?.general?.total ? record.ntc.general.total : '-'}</td>
                <td className="border">{record.ntc?.female?.openCompatibleCount ? record.ntc.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.ntc?.female?.openIncompatibleCount ? record.ntc.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.ntc?.female?.total ? record.ntc.female.total : '-'}</td>

                <td className="border">{record.ntd?.general?.openCompatibleCount ? record.ntd.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.ntd?.general?.openIncompatibleCount ? record.ntd.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.ntd?.general?.total ? record.ntd.general.total : '-'}</td>
                <td className="border">{record.ntd?.female?.openCompatibleCount ? record.ntd.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.ntd?.female?.openIncompatibleCount ? record.ntd.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.ntd?.female?.total ? record.ntd.female.total : '-'}</td>
              </tr>
            </tbody>
          </React.Fragment>
        })}
        <br />
        <thead>
          <tr className='thisis chunk'>
            <th className="border" >{label.Mark}</th>
            <th className="border" colspan="6">{label.OBC}</th>
            <th className="border" colspan="6">{label.SEBC}</th>
            <th className="border" colspan="1">{label.TOTAL}</th>
          </tr>
          <tr>
            <td className="border"></td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.General}</td>
            <td className="border text-nowrap" colspan="3"
            >{label.Female}</td>
            <td></td>
          </tr>
          <tr>
            <td className="border"></td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold">1</td>
            <td className="border font-weight-bold">2</td>
            <td className="border font-weight-bold">Total</td>
            <td className="border font-weight-bold"></td>
          </tr>
        </thead>
        {chunkData?.map((record, index) => {

          return <React.Fragment key={index}>

            <tbody className='border-none'>
              <tr >
                <td className="border">{record.marks}</td>
                <td className="border">{record.obc?.general?.openCompatibleCount ? record.obc.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.obc?.general?.openIncompatibleCount ? record.obc.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.obc?.general?.total ? record.obc.general.total : '-'}</td>
                <td className="border">{record.obc?.female?.openCompatibleCount ? record.obc.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.obc?.female?.openIncompatibleCount ? record.obc.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.obc?.female?.total ? record.obc.female.total : '-'}</td>

                <td className="border">{record.sebc?.general?.openCompatibleCount ? record.sebc.general.openCompatibleCount : '-'}</td>
                <td className="border">{record.sebc?.general?.openIncompatibleCount ? record.sebc.general.openIncompatibleCount : '-'}</td>
                <td className="border">{record.sebc?.general?.total ? record.sebc.general.total : '-'}</td>
                <td className="border">{record.sebc?.female?.openCompatibleCount ? record.sebc.female.openCompatibleCount : '-'}</td>
                <td className="border">{record.sebc?.female?.openIncompatibleCount ? record.sebc.female.openIncompatibleCount : '-'}</td>
                <td className="border">{record.sebc?.female?.total ? record.sebc.female.total : '-'}</td>

                <td className="border">{record.total}</td>
              </tr>
            </tbody>
          </React.Fragment>
        })}
      </table>
    </div>
  )
}

export default DevideTableColumn